<template>
  <li
    :class="[componentClass.root, classes]"
    :title="label"
    @mouseover="emit('highlight')"
    @mouseout="emit('unHighlight')"
  >
    {{ label }}
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useComponentClass } from '@thomasaull-shared/composables'

export interface Props {
  label?: string
  isHighlighted?: boolean
}

const props = withDefaults(defineProps<Props>(), {})

export interface Emits {
  highlight: []
  unHighlight: []
}

const emit = defineEmits<Emits>()

const componentClass = useComponentClass({ props })

const classes = computed(() => {
  return {
    'is-highlighted': props.isHighlighted,
  }
})
</script>

<style lang="scss">
.PmSidebarResourceGroupItemPure {
  $block: &;
  $paddingVertical: 12px;
  $paddingItemVertical: 5px;
  // Fixed height for optimized rendering:
  $height: 22px;

  @include mixin.truncateText;

  font-size: constant.$fontSize-default;
  line-height: 1;
  padding-top: $paddingItemVertical;
  padding-bottom: $paddingItemVertical;
  padding-left: 10px;
  padding-right: 10px;
  list-style: none;
  // content-visibility: auto; // Makes no sense on an otherwise cheap to render element
  contain-intrinsic-size: $height;

  // @include mixin.transition-hover(
  //   (color, background-color),
  //   null,
  //   'highlighted'
  // );

  &:hover,
  &.is-hover,
  &.is-highlighted {
    color: color.$primary-900;
    background-color: color.$primary-100;
  }
}
</style>
